import { Trans } from '@lingui/react/macro'
import { ButtonFilled } from '@vgw/multibrand-fe-button'
import { getBrandConfig } from '@/config/config'
import {
  somethingWentWrongNormal,
  somethingWentWrongHiDPI,
} from '@/features/something-went-wrong-assets'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Layout } from '@/layout/layout'
import { Content } from '@/layout/content'

export const Route = createFileRoute('/age-restricted')({
  component: AgeRestricted,
})

function AgeRestricted() {
  const { ageRestriction } = getBrandConfig()

  return (
    <Layout>
      <Content>
        <main className="flex w-full flex-col bg-page-small-background bg-cover bg-top bg-no-repeat">
          <div className="flex shrink-0 flex-col items-center gap-4 bg-page-gradient px-8 py-10">
            <img
              className="size-32"
              alt=""
              aria-hidden={true}
              src={somethingWentWrongNormal}
              srcSet={`${somethingWentWrongNormal} 122w, ${somethingWentWrongHiDPI} 244w `}
            />
            <div className="flex flex-col items-center gap-3 text-center">
              <h1 className="font-display text-2xl leading-9 font-bold tracking-normal">
                <Trans>Access Restricted</Trans>
              </h1>
              <p className="font-display">
                <Trans>
                  You must be{' '}
                  <span className="font-bold">
                    {ageRestriction} years or older
                  </span>{' '}
                  to play.
                  <br /> As a result, your account has been locked and access is
                  no longer permitted.
                </Trans>
              </p>
              <ButtonFilled asChild>
                <Link to="/">
                  <Trans>Log out</Trans>
                </Link>
              </ButtonFilled>
            </div>
          </div>
        </main>
      </Content>
    </Layout>
  )
}
